export default __webpack_public_path__ + "static/media/twitter-square-brands.4d9d558e.svg";